import { EventEmitter, Injectable, Output } from "@angular/core";
import { API_METHODS, API_URL, OperationType } from 'common/constants/sm-constants';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { SystemService } from 'common/services/core-services/system.service';
import { DataService } from '../../base-data-services/data.service';
import { environment } from 'src/environments/environment';
import { InternshipModel } from 'common/models/page-models/internship/internship/internship-data-model';
import { InternshipDetailsListModel } from 'common/models/page-models/Student Internship List/Intership Details/internship-details-data.model';
import { FormDataService } from "../../base-data-services/form-data.service";
import { TerminateInternshipModel } from "common/models/page-models/Student Internship List/Terminate Internship/terminate-internship-data.model";


@Injectable()
export class InternshipTerminateStudentsDataService extends FormDataService<TerminateInternshipModel> {

  @Output() emitResultGrid = new EventEmitter<any>();
  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.TerminateInternshipStudent, http, ss);
  }

  override getEditUrlAndMethod() {
    const edit = {
      url: environment.apiUrl + API_URL.terminatestudents,
      method: API_METHODS.post
    }
    return edit;
  }

  override modifyAPIResponse(response: any) {
    return response['details'];
  }


  override modifyPostModel(formModel: any, dataModel: any) {
    // formModel.id = this.ss.student_id;
    const submitData : any = {}
    submitData.id = formModel.id;
    submitData.internshipTerminatedReason = formModel.internshipTerminatedReason;
    return submitData;
  }


  createInstance(): TerminateInternshipModel {
    return new TerminateInternshipModel();
  }


  override afterPostData(model: TerminateInternshipModel, result?: any): Promise<TerminateInternshipModel> {
    return new Promise<TerminateInternshipModel>((resolve, reject) => {
      this.emitResultGrid.emit(result)
      resolve(this.transformAPIData(model));
    });
  }

  override generateUrl(type: OperationType, paramKey?: any, extraKey?: any) {
    return environment.apiUrl + this.getAPI_URL();
  }
}